export const errors = (state = [], { type, payload }) => {
  switch (type) {
    case 'ERRORS/ADD':
      return state.concat({
        status: payload.status,
        response: payload.response,
      });
    case 'ERRORS/CLEAR':
      return [];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/errors.js